export default __webpack_public_path__ + "static/media/service_tcp_24.cf09030c.svg";